import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';

export class BeamTower extends Tower {
  private currentBeam: Phaser.GameObjects.Graphics | null = null;
  private beamTarget: Monster | null = null;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 35, attackSpeed: 2.0, range: 170 - continuous beam damage
    super(scene, x, y, 35, 2.0, 170);
    
    this.removeAll();
    this.createBeamVisuals();
  }

  protected override createVisuals(): void {
    // Create beam tower base
    const base = this.scene.add.circle(0, 0, 20, 0x660066);
    this.add(base);
    
    // Create beam emitter
    const emitter = this.scene.add.circle(0, -15, 8, 0xcc00cc);
    this.add(emitter);
    
    // Add energy rings
    const ring1 = this.scene.add.circle(0, 0, 15, 0xff00ff, 0);
    ring1.setStrokeStyle(2, 0xff66ff);
    const ring2 = this.scene.add.circle(0, 0, 25, 0xff00ff, 0);
    ring2.setStrokeStyle(1, 0xff66ff);
    this.add([ring1, ring2]);
  }

  private createBeamVisuals(): void {
    this.createVisuals();
  }

  override update(time: number, delta: number): void {
    super.update(time, delta);
    
    // Update beam targeting
    this.updateBeam();
  }

  private updateBeam(): void {
    // Find target
    const target = this.findTarget();
    
    if (target && target !== this.beamTarget) {
      // New target - create beam
      this.beamTarget = target;
      this.createBeam();
    } else if (!target && this.beamTarget) {
      // Lost target - remove beam
      this.removeBeam();
    } else if (target && this.beamTarget) {
      // Same target - update beam position
      this.updateBeamPosition();
    }
  }

  private createBeam(): void {
    if (this.currentBeam) {
      this.currentBeam.destroy();
    }
    
    this.currentBeam = this.scene.add.graphics();
    this.updateBeamPosition();
  }

  private updateBeamPosition(): void {
    if (!this.currentBeam || !this.beamTarget) return;
    
    this.currentBeam.clear();
    this.currentBeam.lineStyle(4, 0xff00ff, 0.8);
    this.currentBeam.beginPath();
    this.currentBeam.moveTo(this.x, this.y);
    this.currentBeam.lineTo(this.beamTarget.x, this.beamTarget.y);
    this.currentBeam.strokePath();
    
    // Continuous damage
    if (this.beamTarget.getIsActive()) {
      this.beamTarget.takeDamage(this.effectiveDamage * 0.1); // 10% damage per update
    }
  }

  private removeBeam(): void {
    if (this.currentBeam) {
      this.currentBeam.destroy();
      this.currentBeam = null;
    }
    this.beamTarget = null;
  }

  // Override the base attack method to use continuous beam instead
  // protected override attack(target: Monster): void {
  //   // Beam tower uses continuous beam, not projectiles
  //   // Damage is applied in updateBeamPosition
  //   this.audioManager.playTowerAttack(false);
  // }

  override destroy(): void {
    this.removeBeam();
    super.destroy();
  }
} 